import Repository from './repository'

const resource = 'conference'

export default {
    async create(payload) {
        let endpoint = `${resource}/create`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async get({ roomId }) {
        let endpoint = `${resource}/${roomId}`;
        return await Repository.get(endpoint);
    },
    async getInfo({ roomId }) {
        let endpoint = `${resource}/${roomId}/info`;
        return await Repository.get(endpoint);
    },
    async getParticipants({ roomId }) {
        let endpoint = `${resource}/${roomId}/participants`;
        return await Repository.get(endpoint);
    },
    async getMessages({ roomId }) {
        let endpoint = `${resource}/${roomId}/messages`
        return await Repository.get(endpoint);
    },
    async getActions({ roomId }) {
        let endpooint = `${resource}/${roomId}/actions`;
        return await Repository.get(endpooint);
    },
    async getPagedConferences({ page, take, search }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/list/${page}?take=${take}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async closeRoom({ roomId }) {
        let endpoint = `${resource}/${roomId}/close`;
        return await Repository.post(endpoint);
    },
    async getVideos({ roomId }) {
        let endpooint = `${resource}/${roomId}/videos`;
        return await Repository.get(endpooint);
    },
    async getVideo({ videoId }) {
        let endpoint = `${resource}/video/${videoId}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getVideoStream({ videoId }) {
        let endpoint = `${resource}/video/${videoId}/stream`;
        let response = await Repository.get(endpoint);
        return response;
    },
    getVideoStreamUrl({ videoId }) {
        let endpoint = `${Repository.url()}/${resource}/video/${videoId}/stream`;
        return endpoint;
    },
    async getPagedSurveyOnlineUsers({ page, take, search }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/list-survey-online-users/${page}?take=${take}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async setSurveyOnlineUser({ surveyId, environment, roomId }) {
        let endpoint = `${resource}/survey-online-user?surveyId=${surveyId}&environment=${environment}`;
        if (roomId) {
            endpoint = `${endpoint}&roomId=${roomId}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async getPagedOnlineUsers({ page, take, search, status, skill }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/list-online-users/${page}?take=${take}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        if (status !== undefined && status !== null && status !== '') {
            endpoint += `&status=${status}`;
        }
        if (skill !== undefined && skill !== null && skill !== '') {
            endpoint += `&skill=${skill}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async kpi() {
        let endpoint = `${resource}/kpi`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async cleanOnlineUsers() {
        let endpoint = `${resource}/clean-online-user`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getVideoStoragePaths({ roomId }) {
        let endpoint = `${Repository.url()}/${resource}/video-list/${roomId}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getVideoStreamStorage({ path }) {
        let endpoint = `${Repository.url()}/${resource}/video-stream/${path}`;
        let response = await Repository.getBlob(endpoint);
        return response;
    },
    async getVideoStorageZip({ roomId }) {
        let endpoint = `${Repository.url()}/${resource}/video-storage-zip/${roomId}`;
        let response = await Repository.getBlob(endpoint);
        return response;
    },
    async getVideoStorageDownload({ roomId }) {
        let endpoint = `${Repository.url()}/${resource}/video-storage/${roomId}`;
        let response = await Repository.getBlob(endpoint);
        return response;
    }
}
